var exports = {
  "x": "xdde3148b--96f9d6--button",
  "K": "xdde3148b--96f9d6--icon",
};

module.exports = exports;
